import { BindedView } from 'marionette.binding';


const SmsComposeView = BindedView.extend({
  template: require('messaging/templates/sms.html'),

  ui: {
    text: '.textfield.sms',
    count: '.sms-count',
    cost: '.cost'
  },
  
  bindings: {
    'value @ui.text': 'text'
  },

  events: {
    'keyup @ui.text': 'update',
    'update @ui.text': 'update'
  },
  
  update() {
    const count = this.ui.text.val().length || 0;
    this.ui.count.text(count);
    
    let totalMessages = Math.ceil(count / this.smsLength);
    let cost = (
      totalMessages *
      this.getOption('number') *
      this.getOption('config').get('sms_cost'));

    this.ui.cost.text(cost);
  },
  
  initialize() {
    this.smsLength = this.getOption('config').get('sms_length');
  },
  
  onRender() {
    BindedView.prototype.onRender.call(this);
    this.update();
  },

  templateHelpers() {
    return {
      sms_length: this.smsLength
    };
  }
});


export default SmsComposeView;



// WEBPACK FOOTER //
// ./messaging/views/sms.js